import { Trans } from "@lingui/macro";
import { REACT_APP__BASE_PATH } from "@smp/utils";
import { useMemo } from "react";
import { Helmet } from "react-helmet";

import { Screen } from "@/components/layout/screen";
import { getLocationOrigin } from "@/utils";

import { useContextStickers } from "../../context";
import { Content } from "./components/content";
import { SearchBar } from "./components/search_bar";
import { SelectedTags } from "./components/selected_tags";
import { SortDropdown } from "./components/sort_dropdown";
import classes from "./viewpoer.module.css";

export const Viewport = () => {
  const {
    state: { activeStickerId },
  } = useContextStickers();
  const origin = useMemo(getLocationOrigin, []);

  return (
    <>
      {!activeStickerId && (
        <Helmet>
          <meta name="robots" content="noindex" />
          <link
            rel="canonical"
            href={`${origin}${REACT_APP__BASE_PATH}/stickers`}
          />
        </Helmet>
      )}

      <Screen
        title={<Trans>Stickers catalog</Trans>}
        BoxProps={{ className: classes.screen }}
        ContentBoxProps={{ className: classes.content }}
      >
        <div className={classes.content__head}>
          <SearchBar />

          <div className={classes.content__head__secondary}>
            <SelectedTags />
            <SortDropdown />
          </div>
        </div>

        <div className={classes.content__main}>
          <Content />
        </div>
      </Screen>
    </>
  );
};
